module.exports = __webpack_public_path__ + "img/easycob.887ecc35.svg";